/**
 * Supply offers (B16-V3, D54): the vendor's wholesale price W and margin cap on
 * a listing. Pure: no I/O, no React. Mirrors lib/supply/pricing.js on the server
 * (tests/unit/supply-offers.test.js checks they agree); the server decides.
 */
import { rupeesToPaise, paiseToRupees } from './money';

export const MAX_CAP_PCT = 1000;
export const MAX_HANDLING_DAYS = 30;

const capOf = (v) => (v === '' || v == null ? null : Number(v));

/** Highest retail price a reseller may charge, or null for no cap. */
export function maxRetail(wholesalePaise, capPct) {
  const cap = capOf(capPct);
  return cap == null ? null : Math.floor(Number(wholesalePaise) * (1 + cap / 100));
}

export function emptyOfferForm(offer = null) {
  return offer
    ? { listing_id: String(offer.listing_id), wholesale: paiseToRupees(offer.wholesale_paise), cap: offer.max_margin_pct == null ? '' : String(Number(offer.max_margin_pct)), handling_days: String(offer.handling_days ?? 2), enabled: Number(offer.dropship_enabled) === 1 }
    : { listing_id: '', wholesale: '', cap: '', handling_days: '2', enabled: true };
}

/** Form errors ({ field: message }); `listingPrice` is the vendor's own price in paise. */
export function validateOfferForm(f, listingPrice) {
  const e = {};
  if (!f.listing_id) e.listing_id = 'Pick a listing';
  const W = rupeesToPaise(f.wholesale);
  if (!W) e.wholesale = 'Enter the wholesale price in rupees';
  else if (listingPrice != null && W > Number(listingPrice)) e.wholesale = 'The wholesale price cannot be above your own selling price';
  if (f.cap !== '' && !(/^\d+(\.\d{1,2})?$/.test(String(f.cap)) && Number(f.cap) <= MAX_CAP_PCT)) e.cap = `0–${MAX_CAP_PCT}%, or leave empty for no cap`;
  if (!/^\d+$/.test(String(f.handling_days)) || Number(f.handling_days) > MAX_HANDLING_DAYS) e.handling_days = `0–${MAX_HANDLING_DAYS} days`;
  return e;
}

export function offerPayload(f) {
  return {
    listing_id: Number(f.listing_id),
    wholesale_paise: rupeesToPaise(f.wholesale),
    max_margin_pct: f.cap === '' ? null : Number(f.cap),
    handling_days: Number(f.handling_days),
    dropship_enabled: f.enabled ? 1 : 0,
  };
}

/** What a reseller may charge, for the table and the form hint. */
export function resellerRange(wholesalePaise, capPct, fmt) {
  const max = maxRetail(wholesalePaise, capPct);
  return max == null ? `${fmt(wholesalePaise)} or more (no cap)` : `${fmt(wholesalePaise)} – ${fmt(max)}`;
}
